// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout_3W2zH","Main":"Layout_Main_29PO5","HeaderClass":"Layout_HeaderClass_1nqYI","ChildClass":"Layout_ChildClass_2kVni"};